import axios from 'axios';
import httpClient from './httpClient';
import {
  Brand,
  GetAllBrandsResponse,
  GetBrandByIdResponse,
} from '../types/adminbrands-model';

/**
 * Fetches the full list of brands for the admin panel via
 * GET /brand/admin/get-all.
 * Returns the brands array on success, throws an Error on failure.
 */
export const getAllBrands = async (): Promise<Brand[]> => {
  try {
    const { data } = await httpClient.get<GetAllBrandsResponse>(
      '/brand/admin/get-all'
    );
    if (!data.success || !data.result) {
      throw new Error(data.message || 'Failed to fetch brands.');
    }
    return data.result.brands;
  } catch (err) {
    if (axios.isAxiosError<GetAllBrandsResponse>(err)) {
      throw new Error(err.response?.data?.message || 'Failed to fetch brands.');
    }
    throw err;
  }
};

/**
 * Fetches a single brand's full profile via
 * GET /brand/admin/:id.
 * Returns the Brand on success, throws an Error on failure.
 */
export const getBrandById = async (id: string): Promise<Brand> => {
  try {
    const { data } = await httpClient.get<GetBrandByIdResponse>(
      `/brand/admin/${id}`
    );
    if (!data.success || !data.result) {
      throw new Error(data.message || 'Failed to fetch brand details.');
    }
    return data.result;
  } catch (err) {
    if (axios.isAxiosError<GetBrandByIdResponse>(err)) {
      throw new Error(err.response?.data?.message || 'Failed to fetch brand details.');
    }
    throw err;
  }
};